import { z } from "zod";
import { LongText, ShortText, idString } from "./common.js";
export const PROJECT_CONTEXT_OUTCOME_KEYS = [
    "problem-statement",
    "business-impact",
    "expected-outcomes",
    "process-boundaries",
];
export const ProjectContextOutcomeKeySchema = z.enum(PROJECT_CONTEXT_OUTCOME_KEYS);
const OUTCOME_LABELS = {
    "problem-statement": "Problem Statement",
    "business-impact": "Business Impact",
    "expected-outcomes": "Expected Outcomes",
    "process-boundaries": "Process Boundaries",
};
export const ProjectContextStakeholderSchema = z
    .object({
    id: idString,
    role: ShortText.refine((value) => value.trim().length > 0, {
        message: "Role is required.",
    }),
    name: ShortText,
    /** The VSM member this role names, when picked from the members (PB-5441 UX-13). */
    userId: z.string().uuid().nullable().optional(),
})
    .strict();
const ProjectContextOutcomeInputSchema = z
    .object({
    key: ProjectContextOutcomeKeySchema,
    label: ShortText.optional(),
    body: LongText,
    filled: z.boolean().optional(),
})
    .strict()
    .transform(({ key, body }) => ({
    key,
    label: OUTCOME_LABELS[key],
    body,
    filled: body.trim().length > 0,
}));
export const ProjectContextParamsSchema = z
    .object({
    stakeholders: z.array(ProjectContextStakeholderSchema).max(100),
    outcomes: z.array(ProjectContextOutcomeInputSchema).length(4),
})
    .strict()
    .superRefine(({ outcomes, stakeholders }, context) => {
    const stakeholderIds = new Set();
    stakeholders.forEach((stakeholder, index) => {
        if (stakeholderIds.has(stakeholder.id)) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["stakeholders", index, "id"],
                message: `Duplicate stakeholder id '${stakeholder.id}'.`,
            });
        }
        stakeholderIds.add(stakeholder.id);
    });
    const keys = new Set(outcomes.map((outcome) => outcome.key));
    for (const key of PROJECT_CONTEXT_OUTCOME_KEYS) {
        if (!keys.has(key)) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["outcomes"],
                message: `Missing required outcome '${key}'.`,
            });
        }
    }
});
export const defaultProjectContextParams = ProjectContextParamsSchema.parse({
    stakeholders: [
        { id: "sh-sponsor", role: "Sponsor", name: "" },
        { id: "sh-owner", role: "Process Owner", name: "" },
        { id: "sh-lead", role: "Team Leader", name: "" },
    ],
    outcomes: PROJECT_CONTEXT_OUTCOME_KEYS.map((key) => ({
        key,
        body: "",
    })),
});
//# sourceMappingURL=projectContext.js.map